import { render, staticRenderFns } from "./Invites.vue?vue&type=template&id=720049c8&scoped=true&"
import script from "./Invites.vue?vue&type=script&lang=js&"
export * from "./Invites.vue?vue&type=script&lang=js&"
import style0 from "./Invites.vue?vue&type=style&index=0&id=720049c8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "720049c8",
  null
  
)

export default component.exports